import client from './client';

export interface Sensor {
  sensor_ftp_connection_status?:number;
  sensor_modbus_connection_status?:number;
  tags?:Array<{id:number;label:string;color:string}>;
  sensor_plant_count: number;
  sensor_id: number;
  sensor_uuid_id: string;
  sensor_power_plant_id: number;
  sensor_power_plant_uuid_id: string;
  sensor_power_plant_name: string;
  sensor_name: string;
  sensor_brand: string | null;
  sensor_model: string | null;
  sensor_serial_number: string | null;
  sensor_pv_temp: number | null;
  sensor_amp_temp: number | null;
  sensor_radiation: number | null;
  sensor_last_seen: string | null;
  sensor_status: number;
}

export interface SensorDetail {
  sensor_id: number;
  sensor_uuid_id: string;
  sensor_name: string;
  sensor_serial_number: string | null;
  sensor_brand: string | null;
  sensor_model: string | null;
  sensor_power_plant_id: number;
  sensor_power_plant_uuid_id: string;
  sensor_power_plant_name: string;
  sensor_pv_temp: number | null;
  sensor_amp_temp: number | null;
  sensor_radiation: number | null;
  sensor_wind_speed: number | null;
  sensor_wind_direction: number | null;
  sensor_daily_irradiation_kwh: number | null;
  sensor_daily_irradiation: number | null;
  sensor_ftp_connection_status: number;
  sensor_modbus_connection_status: number;
  sensor_ftp_status_code: number | null;
  sensor_modbus_status_code: number | null;
  sensor_last_seen: string | null;
  sensor_status: number;
}

export interface SensorPlant {
  sensor_power_plant_id: number;
  sensor_power_plant_uuid_id: string;
  sensor_power_plant_name: string;
}

export interface SensorDetailResponse {
  sensor: SensorDetail;
  plants: SensorPlant[];
}

export async function fetchSensors(): Promise<Sensor[]> {
  const res = await client.get<Sensor[]>('/sensors');
  return res.data;
}

export async function fetchSensorDetail(uuid_id: string): Promise<SensorDetailResponse> {
  const res = await client.get<SensorDetailResponse>(`/sensors/${uuid_id}`);
  return res.data;
}

export async function fetchPlantSensors(uuid: string, signal?: AbortSignal): Promise<SensorDetail[]> {
  return (await client.get<SensorDetail[]>(`/powerplants/${uuid}/sensors`, { signal })).data;
}
